import React, { Component } from 'react';
import Forecast from './forecast';
import Diff from './diff';

export default class index extends Component {
  state = {
    id: new Date().valueOf()
  }
  render() {
    return (
      <div>
        <Forecast update={() => {
          this.setState({ id: new Date().valueOf() })
        }}></Forecast>
        <Diff id={this.state.id}></Diff>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.1/index.js